import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThemeProps } from 'shared/prop-types/ReducerProps';

class MainWrapper extends PureComponent {
  static propTypes = {
    theme: ThemeProps.isRequired,
    children: PropTypes.element.isRequired,
  };

  render() {
    const { theme, children, className } = this.props;

    return (
      <div className={classnames(theme.className, className)}>
        <div className="wrapper">{children}</div>
      </div>
    );
  }
}

export default connect(state => ({
  theme: state.layout.theme,
}))(MainWrapper);
